import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { HistorialNotificacion } from 'src/app/models/notificacion/historial_notificacion.model';
import { Ventana } from 'src/app/pages/base/ventana';
import { EmpresaService } from 'src/app/services/configuracion/empresa.service';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';
import { JobService } from 'src/app/services/notificacion/job.service';
import { environment } from 'src/environments/environment';
import { Global } from 'src/global';

@Component({
  selector: 'app-historial-notificacion-ventana',
  templateUrl: './historial-notificacion-ventana.component.html',
  styleUrls: ['./historial-notificacion-ventana.component.scss']
})
export class HistorialNotificacionVentanaComponent extends Ventana  implements OnInit {

    tipos = HistorialNotificacion.TIPOS;
    // nombreEmpresa =  String(this.currentUser.nombre_empresa).replace(/ /g,'_').replace(/\./g,'') ;

    urlImage = `${ environment.host }/get_file/notificacion$$`;

    constructor(
        public router: Router,
        public messageService: MessageService,
        public activateRoute: ActivatedRoute,
        public service: HistorialNotificacionService,
        private breadcrumbService: AppBreadcrumbService,
        private empresaService: EmpresaService,
        private jobService: JobService
    ) {
        super(router, activateRoute, messageService, service );
        const modelo = HistorialNotificacion;
        this.modulo = modelo.CODIGO_MODULO;
        this.breadcrumbService.setItems([{ label: 'Notificacion' },{ label: 'Historial de  Notificaciones' , routerLink: `${this.modulo}/historial-notifiacaiones` },{ label: 'Nuevo' }]);
        this.codigoRegistro = modelo.CODIGO_REGISTRO;
        this.objClass = modelo;
        this.navigate = [this.prefixPage, this.modulo, 'historial-notificaciones'];
        this.initComponent();
    }

    ngOnInit(): void {

    }

    /** Estado del envio calculado por el backend a partir del job. */
    get estadoEnvio(): Record<string, any> | null {
        return this.objeto?.estadoEnvio || null;
    }

    retomando = false;

    /**
     * Devuelve la campana a la cola.
     *
     * Solo se ofrece cuando el backend marco el envio como retomable: una
     * campania fallida, que nadie levanta sola, o una interrumpida, para no
     * esperar la recuperacion automatica.
     */
    async onRetomarEnvio() {
        const idJob = this.estadoEnvio?.id;
        const idEmpresa = this.formGroup.get('id_empresa')?.value;

        if (!idJob || !idEmpresa || this.retomando) {
            return;
        }

        this.retomando = true;

        try {
            const resp = await this.jobService.retomarJob(Number(idJob), Number(idEmpresa));

            this.messageService.add({
                severity: resp.ok ? 'success' : 'warn',
                summary: resp.ok ? 'Campana retomada' : 'No se pudo retomar',
                detail: resp.msg,
                life: 8000,
            });

            if (resp.ok) {
                // Recargar para que el estado refleje que volvio a la cola.
                await this.initComponent();
            }
        } finally {
            this.retomando = false;
        }
    }

    async onEmpresa() {
        try {
            const value = this.formGroup.value;  
            let objeto = null;
            const filtros = [
                { field: 'id', value: value.id_empresa, type: 'id' },
                
            ]
            const res = await this.empresaService.getAll( Global.SIZE_GET_ALL, { filters: filtros } );
            if ( res.ok && res.resp.count > 0 ) {
                objeto = res.resp.rows[0];
            } else {
                this.messageService.add({severity: 'info', summary: 'Empresa no encontrada', detail: ''});
            }
            await this.setEmpresa(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async setEmpresa( obj: Record<string, any> ) {
        this.formGroup.get('id_empresa').setValue(obj?.id);
        // this.formGroup.get('ruc_empresa').setValue(obj?.ruc);
        this.formGroup.get('nombre_empresa').setValue(obj?.nombre);
    }

    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClass === Empresa && obj ) {
            await this.setEmpresa(obj);
        }
        this.objClass = null;
    }

    
    async onListaEmpresa() {
        await super.onLista( this.empresaService, Empresa, Empresa.NOMBRE_PLURAL );
    }

}
